import { createContext } from 'react';

import { getI18n } from '#/i18n/getI18n';
import type { I18nFn } from '#/i18n/types/I18nFn';
import { I18nLocale } from '#/i18n/types/I18nLocale';

export const I18nContext = createContext<{ locale: I18nLocale; i18n: I18nFn }>(
  getI18n(I18nLocale.EN),
);
